/**
 * Deteção de marca PWA por hostname (mesmo build em vários domínios).
 */

function getMemberBalcaoMaisHostname() {
  const raw = (process.env.VUE_APP_MEMBER_BALCAO_MAIS || "").trim();
  if (!raw) {
    return "";
  }
  try {
    if (/^https?:\/\//i.test(raw)) {
      return new URL(raw).hostname;
    }
    return raw.split("/")[0].replace(/:\d+$/, "");
  } catch {
    return "";
  }
}

/** @returns {'be' | 'bm' | 'paf'} */
export function getPwaBrandId() {
  const hostname = window.location.hostname;
  const membroHost = getMemberBalcaoMaisHostname();
  if (membroHost && hostname === membroHost) {
    return "bm";
  }
  if (hostname === "clientes.parcialfinance.com") {
    return "paf";
  }
  return "be";
}

export function getPwaBasePath(brandId = getPwaBrandId()) {
  return `/build/pwa/${brandId}`;
}

export function getPwaManifestHref(brandId = getPwaBrandId()) {
  return `${getPwaBasePath(brandId)}/manifest.webmanifest`;
}

export function getPwaApplicationName(brandId = getPwaBrandId()) {
  if (brandId === "bm") {
    return "Balcão Mais - Membro";
  }
  if (brandId === "paf") {
    return "ParcialFinance - Cliente";
  }
  return "Balcão do Emigrante";
}

export function applyPwaHeadTags() {
  const brandId = getPwaBrandId();
  const base = getPwaBasePath(brandId);
  const appName = getPwaApplicationName(brandId);

  document
    .querySelectorAll(
      'link[rel="icon"], link[rel="apple-touch-icon"], link[rel="shortcut icon"], link[rel="manifest"], meta[name^="apple-mobile-web-app"], meta[name="application-name"], meta[name="mobile-web-app-capable"]'
    )
    .forEach((el) => el.remove());

  const head = document.head;
  head.insertAdjacentHTML(
    "beforeend",
    `
      <link rel="manifest" href="${base}/manifest.webmanifest" />
      <link rel="icon" type="image/png" href="${base}/favicon.png" sizes="48x48" />
      <link rel="apple-touch-icon" sizes="180x180" href="${base}/apple-touch-icon.png" />
      <meta name="application-name" content="${appName}" />
      <meta name="apple-mobile-web-app-title" content="${appName}" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="mobile-web-app-capable" content="yes" />
    `
  );

  const themeMeta = document.querySelector('meta[name="theme-color"]');
  if (themeMeta) {
    if (brandId === "paf") {
      themeMeta.setAttribute("content", "#0a2240");
    } else if (brandId === "be") {
      themeMeta.setAttribute("content", "#054e7a");
    } else {
      themeMeta.setAttribute("content", "#ffffff");
    }
  }
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return null;
  }
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch {
    return null;
  }
}
